import React from "react"
import { Card, Title, Image, Description, ExternalLink } from "./styles"
import Countdown from "../Countdown/Countdown"

// test

const CourseCard = ({
  title,
  image,
  description,
  typeOfCourse,
  coupon,
  linkWithCoupon,
  linkPaid,
  price,
  deadline,
}) => {
  const finalLink = coupon ? linkWithCoupon : linkPaid
  return (
    <Card>
      <Title> {title}</Title>
      <Image srcSet={image} alt="Course img" />
      <Description>{description}</Description>
      {typeOfCourse === "course-free" && (
        <ExternalLink href={finalLink} target="_blank">
          Curso Gratis
        </ExternalLink>
      )}
      {/* CUPON NUEVO */}
      {typeOfCourse === "course-semi-premium" && coupon && (
        <>
          <Countdown deadline={deadline} type="discount" />
          <ExternalLink href={finalLink} target="_blank">
            Curso Gratis
          </ExternalLink>
        </>
      )}
      {/* PRÓXIMO CUPON */}
      {typeOfCourse === "course-semi-premium" && !coupon && (
        <>
          {/* <Countdown deadline={deadline} type="nextCoupon" />
          <ExternalLink href={finalLink} target="_blank">
            Comprar por {price} €
          </ExternalLink> */}
          <ExternalLink>Proximamente</ExternalLink>
        </>
      )}
      {typeOfCourse === "course-premium" && coupon && (
        <ExternalLink href={finalLink} target="_blank">
          Comprar por {price} €
        </ExternalLink>
      )}
      {typeOfCourse === "course-premium" && !coupon && (
        <ExternalLink>Proximamente</ExternalLink>
      )}
    </Card>
  )
}

export default CourseCard
